import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useMutationMeUpdate } from 'gql/mutations/me';
import { useQueryMe } from 'gql/queries/me';
import useSiteContext from 'hooks/useSiteContext';
import { trackEvent, reportError } from 'lib/tracking';

import DownloadApp from './DownloadApp';

const DownloadAppContainer = () => {
  const { t } = useTranslation();
  const { isInNative } = useSiteContext();
  const [browser] = useState(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream; // !window.MSStream is to not incorrectly detect IE11
    const isAndroid = /android/i.test(userAgent);
    const isWindows = /windows phone/i.test(userAgent);
    const isInStandaloneMode =
      'standalone' in window.navigator && window.navigator.standalone;
    return isIOS && !isInStandaloneMode && !isInNative
      ? 'iOS'
      : (isAndroid || isWindows) && !isInStandaloneMode && !isInNative
      ? 'Android'
      : undefined;
  }, []);
  const { isLoading, data } = useQueryMe();
  const metadataMe = useMemo(
    () => (isLoading ? {} : data.me.metadata),
    [data, isLoading],
  );
  const tagsMe = isLoading ? [] : data.me.tags;
  const isOpen = isLoading
    ? false
    : !metadataMe?.ignoreApp && tagsMe.includes('onboarded') && !!browser;
  const mutationMeUpdate = useMutationMeUpdate();
  const handleClose = useCallback(async () => {
    try {
      await mutationMeUpdate({
        metadata: {
          ...metadataMe,
          ignoreApp: true,
        },
      });
      trackEvent('me:update', 'metadata:ignoreApp');
    } catch (err) {
      reportError('me:update', 'metadata:ignoreApp', err);
    }
  }, [metadataMe, mutationMeUpdate]);
  return isOpen ? (
    <DownloadApp browser={browser} handleClose={handleClose} t={t} />
  ) : null;
};

export default DownloadAppContainer;
